import { Input, Spin } from "antd";
import type { ChangeEvent, FC } from "react";
import { useCallback } from "react";

import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { SecondaryButton } from "../../../Buttons/components/ActionButton";
import { IconCodes } from "../../../Icon/IconCodes";
import { Icon } from "../../../index";
import { useLazyLoadConfigValueQuery } from "../../services/server/formComponentsApi";
import type { AntCustomFormField } from "../../types/types";
import { buttonStyle, inputStyle } from "./buttonGeneratorStyle";

interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
    siteId: string;
}

export const SiteIdCopyGenerator: FC<InputGeneratorProps> = ({ siteId, readOnly, onChange, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    const [data, { isFetching }] = useLazyLoadConfigValueQuery();

    const onClick = useCallback(() => {
        if (onChange) {
            const urlToFetchOptions = `/${ResourceName.SITE_ID_COPY_GENERATOR}?siteId=${siteId}`;
            data(urlToFetchOptions)
                .unwrap()
                .then((response) => {
                    if (response.value) {
                        onChange(response.value);
                    }
                });
        }
    }, [siteId, data, onChange]);

    const dataGroup = getAssignedDataGroup();
    const disableButton: boolean = !(dataGroup?.siteIdMinLength && dataGroup?.siteIdMaxLength && dataGroup?.siteIdPrefixes);

    return (
        <Spin spinning={isFetching}>
            <Input.Group compact>
                <Input readOnly={readOnly || isFetching} onChange={onValueChange} style={inputStyle} {...restProps} />
                <SecondaryButton
                    name="siteIdGenerator_button"
                    onClick={onClick}
                    disabled={readOnly || isFetching || disableButton}
                    icon={<Icon iconName={IconCodes.RedoOutlined} />}
                    style={buttonStyle}
                />
            </Input.Group>
        </Spin>
    );
};
